import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightStyle = styled('div')`
  .insightdetail {
    &--header {
      ${media.mobile} {
        padding-top: 48px;
      }
      ${media.desktop} {
        padding-top: 55px;
      }
      &-title {
        font-family: 'Pretendard-Bold';
        color: #333333;
        margin: 0 auto;
        text-align: center;
        word-break: keep-all;
        ${media.mobile} {
          font-size: 24px;
          line-height: 32px;
          width: calc(100% - 100px);
        }
        ${media.desktop} {
          font-size: 28px;
          max-width: 538px;
        }
      }

      &-tags {
        display: flex;
        justify-content: center;
        margin-top: 8px;
        flex-wrap: wrap;
        ${media.desktop} {
          margin-top: 12px;
        }
      }
      &-tag {
        font-size: 14px;
        color: #999999;
        margin-right: 12px;
      }
    }
    &--body {
      ${media.mobile} {
        margin-top: 32px;
        padding: 0 20px 21px;
      }
      ${media.desktop} {
        width: 840px;
        margin: 60px auto;
      }
      &-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 61px;
      }
    }
    &--button {
      display: block;
      padding: 13px 32px;
      margin: 60px auto 0;
      background-color: #333333;
      color: #ffffff;
      font-size: 15px;
      font-family: 'Pretendard-Bold';
      ${media.desktop} {
        margin-top: 77px;
      }
    }
    &--shares {
      display: flex;
      &-item {
        ${media.mobile} {
          margin-top: -1px;
        }
      }
      &-item-circle {
        width: 34px;
        height: 34px;
        border: 1px solid #e0e0e0;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
        &.url {
          font-family: 'Gilroy-ExtraBold';
          font-size: 12px;
          color: #cfcfcf;
        }
      }
    }
    &--list {
      border: 1px solid #e0e0e0;
      font-size: 12px;
      color: #757575;
      flex: none;
      width: 69px;
      text-align: center;
      padding-top: 6px;
      height: 24px;
    }
    &--relations {
      ${media.desktop} {
        background-color: #f6f6f6;
        padding-bottom: 121px;
        width: calc(100vw - 214px);
        margin-left: calc((50vw - 579px) * -1);
      }
      ${media.mobile} {
        border-bottom: 20px solid #f6f6f6;
      }
      &-content {
        ${media.desktop} {
          width: 824px;
          margin: 0 auto;
        }
      }
      &-title {
        font-family: 'Nanum-Myeongjo-Bold';
        font-size: 16px;
        color: #333333;
        background-color: #f6f6f6;
        ${media.mobile} {
          padding: 19px 20px;
        }
        ${media.desktop} {
          font-size: 18px;
          padding-top: 30px;
          padding-bottom: 16px;
        }
      }
      &-body {
        ${media.mobile} {
          padding: 0 20px;
        }
        ${media.desktop} {
          margin-top: 4px;
          .insightlist--item,
          .insightcard--image {
            width: 264px;
            height: 181px;
          }
        }
      }
    }
  }
`;

export default InsightStyle;
